import type { CalcKey } from './calculator';

export const ROWS: [CalcKey, string][][] = [
  [
    ['MC', 'MC'],
    ['MR', 'MR'],
    ['MS', 'MS'],
    ['M+', 'M+'],
    ['M-', 'M−'],
  ],
  [
    ['BS', '⌫'],
    ['CE', 'CE'],
    ['C', 'C'],
    ['NEG', '±'],
    ['SQRT', '√'],
  ],
  [
    ['7', '7'],
    ['8', '8'],
    ['9', '9'],
    ['/', '÷'],
    ['PCT', '%'],
  ],
  [
    ['4', '4'],
    ['5', '5'],
    ['6', '6'],
    ['*', '×'],
    ['=', '='],
  ],
  [
    ['1', '1'],
    ['2', '2'],
    ['3', '3'],
    ['-', '−'],
    ['+', '+'],
  ],
  [
    ['0', '0'],
    ['.', '.'],
  ],
];
